'use strict';

// Conserva fetch antes de reemplazarlo para evitar llamadas recursivas.
const originalFetch = window.fetch.bind(window)
const csrfTokenUrl = './server/php/auth/csrfToken.php'
let csrfToken = ''
let csrfTokenRequest = null

async function getCsrfToken(){
    if(csrfToken !== ''){
        return csrfToken
    }

    if(csrfTokenRequest === null){
        csrfTokenRequest = originalFetch(csrfTokenUrl, {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { 'Accept': 'application/json' }
        })
        .then((response) => {
            if(!response.ok){
                throw new Error('Unable to obtain CSRF token')
            }
            return response.json()
        })
        .then((result) => {
            if(typeof result.csrfToken !== 'string' || result.csrfToken === ''){
                throw new Error('Invalid CSRF token response')
            }
            csrfToken = result.csrfToken
            return csrfToken
        })
        .catch((error) => {
            csrfTokenRequest = null
            throw error
        })
    }

    return csrfTokenRequest
}

window.fetch = async function(input, init = {}){
    const request = new Request(input, init)
    const method = request.method.toUpperCase()
    const requestUrl = new URL(request.url)

    if(
        requestUrl.origin === window.location.origin &&
        !['GET', 'HEAD', 'OPTIONS'].includes(method)
    ){
        const token = await getCsrfToken()
        const headers = new Headers(request.headers)
        headers.set('X-CSRF-Token', token)

        return originalFetch(new Request(request, { headers }))
    }

    return originalFetch(request)
}
